import { css } from "styled-components";

/** Breakpoint padrão mobile/tablet da plataforma autenticada */
export const MOBILE_MAX = "768px";

/**
 * Conteúdo ao lado da sidebar — full width no mobile
 * (sidebar vira drawer fixed e sai do fluxo).
 */
export const mobileAuthSideContainer = css`
  @media screen and (max-width: ${MOBILE_MAX}) {
    width: 100% !important;
    max-width: 100vw;
    margin: 0 !important;
    margin-left: 0 !important;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 3.75rem; /* espaço do botão menu */
    box-sizing: border-box;
    overflow-x: hidden;
  }
`;

export const mobileAuthMainContainer = css`
  @media screen and (max-width: ${MOBILE_MAX}) {
    flex-direction: row;
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
  }
`;
